        <template>
  <div
      >
    <b-row
              class="match-height"
          >
                                    <b-col
                                                          lg="7"
                                                                    >
                            <main-info
  :data="{&quot;name&quot;:&quot;-&quot;,&quot;enter&quot;:&quot;-&quot;,&quot;date&quot;:&quot;-&quot;,&quot;status&quot;:&quot;-&quot;,&quot;count&quot;:&quot;-&quot;,&quot;status2&quot;:&quot;-&quot;,&quot;active&quot;:&quot;-&quot;}"
  api="https://api.prohealthfactor.ru/api/v1/json/lkb/dashboad/data/page/maininfo"
/>            </b-col>
                                        <b-col
                                                          lg="5"
                                                                    >
                            <promo
  :data="{&quot;link&quot;:&quot;&quot;,&quot;link2&quot;:&quot;&quot;,&quot;code&quot;:&quot;&quot;}"
  api="https://api.prohealthfactor.ru/api/v1/json/lkb/dashboad/data/page/promo"
/>            </b-col>
                                        <b-col
                                                          lg="4"
                                                                    >
                            <html-content
  api="https://api.prohealthfactor.ru/api/v1/htm/lkb/dashboad/data/page/struct"
    :innerHTML="true"
  />            </b-col>
                                        <b-col
                                                          lg="3"
                                                                    >
                            <html-content
  api="https://api.prohealthfactor.ru/api/v1/htm/lkb/dashboad/data/page/marketing"
    :innerHTML="true"
  />            </b-col>
                                        <b-col
                                                          lg="5"
                                                                    >
                            <course
  title=""
  api="https://api.prohealthfactor.ru/api/v1/json/lkb/dashboad/data/page/learn"
/>
            </b-col>
                                        <b-col
                                                                                      sm="12"
                                        >
              <b-row
                              >
                                  <b-col
                                                                                  lg="7"
                                                                                                    >
                                            <news-promotions
  :data="null"
  api="https://api.prohealthfactor.ru/api/v1/json/lkb/dashboad/data/page/newspromotions"
/>                  </b-col>
                                  <b-col
                                                                                  lg="5"
                                                                                                    >
                                            <messages
  api="https://api.prohealthfactor.ru/api/v1/json/lkb/dashboad/data/page/msg"
/>                  </b-col>
                                </b-row>
            </b-col>
                                        <b-col
                                                                                                >
                            <sp-modal-form
            sendApi="https://api.prohealthfactor.ru/api/v1/json/lkb/buyer/contract/add"
            method="post"
            getApi=""
            id="sp-modal-form"
            title="Добавить партнера"
    />
            </b-col>
                            </b-row>
  </div>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BRow,
  BCol,
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'

                                      import MainInfo from '@core/components/dashboard/MainInfo.vue'
                                                              import Promo from '@core/components/dashboard/Promo.vue'
                                                              import HtmlContent from '@core/components/html-content/HtmlContent.vue'
                                                                                    import Course from '@core/components/dashboard/Course.vue'
                                                                            import NewsPromotions from '@core/components/dashboard/NewsPromotions.vue'
                                                                        import Messages from '@core/components/messages/Messages.vue'
                                                                          import SpModalForm from '@core/components/sp/sp-modal-form/SpModalForm.vue'
                            
export default {
  components: {
    BRow,
    BCol,

                                                          MainInfo,
                                                                              Promo,
                                                                              HtmlContent,
                                                                                                              Course,
                                                                                              NewsPromotions,
                                                                            Messages,
                                                                                            SpModalForm,
                                          },
  setup() {
              
          return {
            }
      },
}
</script>
    